export default "/assets/images/critter-cuddler3.a7ec28c6d9b4034a.png";